import * as $ from 'jquery';
import {Global} from '../init-global';

require('jquery-debounced-and-throttled-resize/jquery.debouncedresize.js');
require("waypoints/lib/jquery.waypoints.js");
const simpleParallax = require('simple-parallax-js');


export class PinboardTiles {

    protected $root: JQuery;
    protected isMobile: boolean;
    protected breakpoint: number = 980;

    protected $tiles:JQuery;
    protected $intro:JQuery;
    protected photoOne: JQuery;
    protected photoTwo: JQuery;
    protected photoThree: JQuery;
    protected photoFour: JQuery;
    protected photoFive: JQuery;
    protected photoSix: JQuery;

    protected triggerIntro: Waypoint;
    protected trigger1: Waypoint;
    protected trigger2: Waypoint;
    protected trigger3: Waypoint;
    protected trigger4: Waypoint;
    protected trigger5: Waypoint;
    protected trigger6: Waypoint;


    constructor(elem: HTMLElement)
    {
        this.$root = $(elem);
        this.bindUI();
    }

    private bindUI = () => {
        this.photoOne   = $('#pin-item-1', this.$root);
        this.photoTwo   = $('#pin-item-2', this.$root);
        this.photoThree = $('#pin-item-3', this.$root);
        this.photoFour  = $('#pin-item-4', this.$root);
        this.photoFive  = $('#pin-item-5', this.$root);
        this.photoSix   = $('#pin-item-6', this.$root);
        this.$intro     = $('.l-pinboard-grid__container', this.$root);

        this.refreshViewport();
        // Watch the viewport for size changes
        $(window).on('debouncedresize', () => this.refreshViewport());
    }

    private initDesktop = () => {
       this.trigger1     = new Waypoint({ element: this.photoOne.get(0), handler: (direction:any) => { this.photoOne.toggleClass('dsp-triggered', direction == 'down'); }, offset: '80%' });
       this.trigger2     = new Waypoint({ element: this.photoTwo.get(0), handler: (direction:any) => { this.photoTwo.toggleClass('dsp-triggered', direction == 'down'); }, offset: '60%' });
       this.trigger3     = new Waypoint({ element: this.photoThree.get(0), handler: (direction:any) => { this.photoThree.toggleClass('dsp-triggered', direction == 'down'); }, offset: '70%' });
       this.trigger4     = new Waypoint({ element: this.photoFour.get(0), handler: (direction:any) => { this.photoFour.toggleClass('dsp-triggered', direction == 'down'); }, offset: '90%' });
       this.trigger5     = new Waypoint({ element: this.photoFive.get(0), handler: (direction:any) => { this.photoFive.toggleClass('dsp-triggered', direction == 'down'); }, offset: '70%' });
       this.trigger6     = new Waypoint({ element: this.photoSix.get(0), handler: (direction:any) => { this.photoSix.toggleClass('dsp-triggered', direction == 'down'); }, offset: '90%' });
       this.triggerIntro = new Waypoint({ element: this.$intro.get(0), handler: (direction:any) => { this.$intro.toggleClass('dsp-triggered', direction == 'down'); }, offset: '80%' });
    }

    private initMobile = () => {
       this.trigger1     = new Waypoint({ element: this.photoOne.get(0), handler: (direction:any) => { this.photoOne.toggleClass('dsp-triggered', direction == 'down'); }, offset: '85%' });
       this.trigger2     = new Waypoint({ element: this.photoTwo.get(0), handler: (direction:any) => { this.photoTwo.toggleClass('dsp-triggered', direction == 'down'); }, offset: '70%' });
       this.trigger3     = new Waypoint({ element: this.photoThree.get(0), handler: (direction:any) => { this.photoThree.toggleClass('dsp-triggered', direction == 'down'); }, offset: '80%' });
       this.trigger4     = new Waypoint({ element: this.photoFour.get(0), handler: (direction:any) => { this.photoFour.toggleClass('dsp-triggered', direction == 'down'); }, offset: '70%' });
       this.trigger5     = new Waypoint({ element: this.photoFive.get(0), handler: (direction:any) => { this.photoFive.toggleClass('dsp-triggered', direction == 'down'); }, offset: '50%' });
       this.trigger6     = new Waypoint({ element: this.photoSix.get(0), handler: (direction:any) => { this.photoSix.toggleClass('dsp-triggered', direction == 'down'); }, offset: '80%' });
       this.triggerIntro = new Waypoint({ element: this.$intro.get(0), handler: (direction:any) => { 
           this.$intro.toggleClass('dsp-triggered', direction == 'down');
       }, offset: '70%' });
    }

    private resetTriggers = () => {
        if (typeof this.trigger1     != 'undefined') { this.trigger1.destroy(); }
        if (typeof this.trigger2     != 'undefined') { this.trigger2.destroy(); }
        if (typeof this.trigger3     != 'undefined') { this.trigger3.destroy(); }
        if (typeof this.trigger4     != 'undefined') { this.trigger4.destroy(); }
        if (typeof this.trigger5     != 'undefined') { this.trigger5.destroy(); }
        if (typeof this.trigger6     != 'undefined') { this.trigger6.destroy(); }
        if (typeof this.triggerIntro != 'undefined') { this.triggerIntro.destroy(); }
    }

    private refreshViewport = () => {
        let vp = Global.getViewport();
        let dspForMobile:boolean = (vp.width < this.breakpoint) ? true: false;

        if (dspForMobile != this.isMobile) {
            this.isMobile = dspForMobile;
            this.resetTriggers();
            (this.isMobile) ? this.initMobile(): this.initDesktop();
        }
    }
}